import ImporterLineStatsSearchResultP from "./presenter/recordm.presenter.searchresult.importer.stats.details.js";
import ImporterStatsAdvancedSearchM from "./model/recordm.importer.model.stats.advancedsearch.js";
import ImporterStatsDetailsV from './view/recordm.importer.view.stats.details.js';
import ImporterStatsSearchM from "./model/recordm.importer.model.stats.simplesearch.js";
import MultipleSearchP from "./presenter/recordm.presenter.multiplesearch.js";
import RecordmImporterLineStatM from "./model/recordm.importer.model.stat.line.js";
import RecordmImporterSummaryStatM from "./model/recordm.importer.model.stat.summary.js";
import SearchVisGroupM from "./model/recordm.model.searchvisgroup.js";
import ui from '@cob/ui-genesis/cob.ui.js';

const RmImporterStatsDetails = function(core) {
    let _running = false;
    let _isRefreshing = false;
    let _refreshTimeout;

    let _detailsV;

    let _searchP,
        _searchResultP;

    let _viewId,
        _searchQuery,
        _searchMode;

    const _summaryStatM = new RecordmImporterSummaryStatM(core);
    const _loadingKey = core.getLoadingKey();

    // load all _views associated with this definition
    const _loadViews = function(settingKey, onDone) {
        SearchVisGroupM.loadAll(core, settingKey, function(views) {
            onDone(views);
        });
    };

    const _onStatLoaded = function() {
        core.hideLoading(_loadingKey, "get StatM");

        if(_isRefreshing){
            _detailsV.refresh();
            _searchP.refresh();

            if(_summaryStatM.isDone()){
                _detailsV.stopRefresh();
                _isRefreshing = false;
                window.clearTimeout(_refreshTimeout);
            } else {
                _refreshTimeout = window.setTimeout(function() {
                    _summaryStatM.refresh();
                }, 2000);
            }

            return;
        }

        //Give a "dummy" summary row JSON so it can build URIs for the current stat details when searching
        const dummyLineStatM = new RecordmImporterLineStatM(core, {
            "_id": _summaryStatM.getId(),
            "_source":{}
        });

        _loadViews(dummyLineStatM.getSettingKey(), function(views) {
            const visualizationGroupM = new SearchVisGroupM(core, dummyLineStatM, views);
            let searchM;

            const advSearchM = new ImporterStatsAdvancedSearchM(core,
                "recordm/importer-stats/search/advanced",
                "recordm/importer-stats/download/advanced",
                "recordm/importer-stats/download"
            );

            const simpleSearchM = new ImporterStatsSearchM(core);

            _detailsV = new ImporterStatsDetailsV(core, _summaryStatM, {
                refresh: function() {
                    _isRefreshing = true;
                    _summaryStatM.refresh();
                },
                stopRefresh: function() {
                    _isRefreshing = false;
                    _detailsV.stopRefresh();
                    window.clearTimeout(_refreshTimeout);
                },
                setSearchFilter: function(filter) {
                    _searchP.setQuery(filter);
                }
            });

            if(_running) _detailsV.start();

            if (_searchMode === 'aq') {
                try {
                    _searchQuery = JSON.parse(_searchQuery || []);
                } catch (e) {
                    // if there's malformed json in the url don't error out.
                    _searchQuery = [];
                }
                searchM = advSearchM;
            } else {

                if(!_searchQuery){
                    _searchQuery = "*";
                }

                searchM = simpleSearchM;
            }

            //In this module we only want to show the "line" stats for the selected "summary" stat
            searchM.filterLineStatsFor(_summaryStatM.getImportId());

            // In this module we want to sort the line stats by their row number
            searchM.setDefaultSort("row_num", true);

            _searchP = MultipleSearchP(
                core,
                "importer-stats/" + _summaryStatM.getId(),
                _detailsV.getSearchContainer(),
                dummyLineStatM,
                simpleSearchM,
                advSearchM,
                visualizationGroupM
            );

            _searchResultP = new ImporterLineStatsSearchResultP(
                core,
                searchM,
                visualizationGroupM,
                _detailsV.getResultsContainer()
            );
            _searchResultP.init(_searchQuery, _viewId);

            _searchP.init(_searchQuery, _viewId);

            _detailsV.addFilterBtns();

            _searchP.prepareView();
        });
    };

    const _onStatError = function(e, data) {
        const status = data.status || 0;

        core.hideLoading(_loadingKey, "get StatM");
        ui.notification.showError(core.translateString("recordm.error.codes", "generic." + status));
    };

    const _subscribeEvents = function() {
        core.subscribe("recordm:rm-importer-stats:success", _onStatLoaded);
        core.subscribe("recordm:rm-importer-stats:error", _onStatError);
    };

    const _unsubscribeEvents = function() {
        core.unsubscribe("recordm:rm-importer-stats:success", _onStatLoaded);
        core.unsubscribe("recordm:rm-importer-stats:error", _onStatError);
    };

    const _init = function(instanceId, searchMode, searchQuery, activeVisualizationId) {
        _running = true;

        _subscribeEvents();

        _searchMode = searchMode;
        _searchQuery = searchQuery;
        _viewId = (activeVisualizationId !== "undefined"
                   ? parseInt(activeVisualizationId, 10)
                   : undefined);

        core.showLoading(_loadingKey, "get StatM");

        _summaryStatM.get(instanceId);
    };

    const _pause = function() {
        _running = false;
        _isRefreshing = false;

        _unsubscribeEvents();

        if (_summaryStatM) {
            _searchP.pause();
            _searchResultP.pause();

            _detailsV.pause();
        }
    };

    const _resume = function() {
        _running = true;

        _subscribeEvents();

        if (_summaryStatM) {
            _detailsV.resume();

            _searchP.resume();
            _searchResultP.resume();

            _searchP.prepareView();
            _searchResultP.prepareView();
        }
    };

    const _destroy = function() {
        _running = false;
        _isRefreshing = false;

        _unsubscribeEvents();

        if (_summaryStatM) {
            _searchP.destroy();
            _searchResultP.destroy();

            _detailsV.stop();

            _summaryStatM.release();
        }
    };

    const _getDescription = function() {

    };

    return {
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,
        getDescription: _getDescription
    }
};

export default RmImporterStatsDetails;
